import React from "react";
import "./discover.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Discover = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="discover-section">

        {/* <img
          src="\assets\landing\discover\discover-bg.png"
          alt="img"
          className="img-fluid discover-bg"
        /> */}
        <div className="custom-container">
               
          <div className="parent">
            <div className="main-content">
              <div>
<h4>Discover Early Opportunities on the XEN Launchpad</h4>
              <p>
                Access private sale opportunities before public launch. XEN
                gives investors structured entry into early rounds designed for
                participants seeking allocation before exchange exposure.
                <br></br>
                Participate early. Position ahead of the market.
              </p>
              </div>
              

              <Link to="/launchpad" className="btn-see-all">
                {t("Discover4")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M3.75 9H14.25"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 3.75L14.25 9L9 14.25"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Discover;
